import React, { useState, useRef } from 'react';
import useStore from '../store';
import { PlusIcon } from '../icons/Icons';

function parseTimeToMinutes(timeStr) {
  const [h, m] = timeStr.split(':').map(Number);
  return h * 60 + m;
}

function getPersonStatus(person) {
  const now = new Date();
  const nowMinutes = now.getHours() * 60 + now.getMinutes();

  const arrivedMinutes = parseTimeToMinutes(person.arrivedAt);
  let leftMinutes = parseTimeToMinutes(person.leftAt);

  if (leftMinutes <= arrivedMinutes) {
    leftMinutes += 24 * 60;
  }

  let nowAdjusted = nowMinutes;
  if (nowAdjusted < arrivedMinutes && leftMinutes > 24 * 60) {
    nowAdjusted += 24 * 60;
  }

  return nowAdjusted >= arrivedMinutes && nowAdjusted < leftMinutes;
}

function TimePopup({ person, onSave }) {
  const [arrived, setArrived] = useState(person.arrivedAt);
  const [left, setLeft] = useState(person.leftAt);

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onSave(person.id, arrived, left);
    }
  };

  return (
    <div className="alert-overlay" onClick={handleOverlayClick}>
      <div className="alert-box">
        <h3 className="alert-title">{person.name}</h3>
        <div className="alert-body">
          <div className="form-row">
            <div className="form-group">
              <label>Пришёл</label>
              <input type="time" value={arrived} onChange={(e) => setArrived(e.target.value)} />
            </div>
            <div className="form-group">
              <label>Ушёл</label>
              <input type="time" value={left} onChange={(e) => setLeft(e.target.value)} />
            </div>
          </div>
        </div>
        <div className="alert-buttons-column">
          <button className="btn-primary" onClick={() => onSave(person.id, arrived, left)}>
            Сохранить
          </button>
          <button className="btn-cancel" onClick={() => onSave(person.id, person.arrivedAt, person.leftAt)}>
            Отмена
          </button>
        </div>
      </div>
    </div>
  );
}

export default function PeopleScreen() {
  const banya = useStore((s) => s.banya);

  // Пастельная палитра цветов для участников
  const colors = [
    { bg: '#ff8a80' },
    { bg: '#82b1ff' },
    { bg: '#b9f6ca' },
    { bg: '#ffd740' },
    { bg: '#e0b0ff' },
    { bg: '#80deea' },
    { bg: '#ffab91' },
    { bg: '#aed581' },
    { bg: '#f48fb1' },
    { bg: '#9fa8da' },
  ];
  const addPerson = useStore((s) => s.addPerson);
  const removePerson = useStore((s) => s.removePerson);
  const updatePersonName = useStore((s) => s.updatePersonName);
  const updatePersonTimes = useStore((s) => s.updatePersonTimes);
  const updatePersonEmoji = useStore((s) => s.updatePersonEmoji);

  const [swipedId, setSwipedId] = useState(null);
  const touchStartX = useRef(null);
  const [editingPerson, setEditingPerson] = useState(null);
  const [emojiPickerPerson, setEmojiPickerPerson] = useState(null);

  if (!banya) return null;

  const handleTouchStart = (e, id) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = (e, id) => {
    const diff = touchStartX.current - e.changedTouches[0].clientX;
    if (diff > 80) {
      setSwipedId(id);
    } else {
      setSwipedId(null);
    }
  };

  const handleDelete = (id) => {
    removePerson(id);
    setSwipedId(null);
  };

  const startEditingTime = (person) => {
    setEditingPerson(person);
  };

  const canDelete = banya.people.length > 1;

  return (
    <div className="people-section">
      {banya.people.map((person) => {
        const isOnBanya = getPersonStatus(person);

        return (
          <div
            key={person.id}
            className={`person-item ${swipedId === person.id ? 'swiped' : ''}`}
            onTouchStart={(e) => handleTouchStart(e, person.id)}
            onTouchEnd={(e) => handleTouchEnd(e, person.id)}
            onClick={() => { if (swipedId === person.id) setSwipedId(null); }}
          >
            <div className="person-item-left">
              <div className="emoji-badge" onClick={(e) => { e.stopPropagation(); setEmojiPickerPerson(person.id); }}>
                {person.emoji || '😎'}
                <span className={`status-dot-inline ${isOnBanya ? 'on' : 'off'}`} />
              </div>
              {(() => { const idx = banya.people.findIndex(p => p.id === person.id); const c = colors[idx % colors.length]; return (
              <input
                className="person-name badge-name"
                value={person.name}
                onChange={(e) => updatePersonName(person.id, e.target.value)}
                style={{ backgroundColor: c.bg }}
              />)})()}

              <span className="person-times" onClick={(e) => { e.stopPropagation(); startEditingTime(person); }}>
                {person.arrivedAt}—{person.leftAt}
              </span>
            </div>

            {canDelete && (
              <button className="delete-swipe" onClick={(e) => { e.stopPropagation(); handleDelete(person.id); }}>
                Удалить
              </button>
            )}
          </div>
        );
      })}

      <button className="add-person-btn" onClick={addPerson}>
        <PlusIcon /> Добавить человека
      </button>

      {editingPerson && (
        <TimePopup
          key={editingPerson.id}
          person={editingPerson}
          onSave={(id, arrived, left) => {
            updatePersonTimes(id, arrived, left);
            setEditingPerson(null);
          }}
        />
      )}

      {emojiPickerPerson && (() => {
        const ep = banya.people.find(p => p.id === emojiPickerPerson);
        if (!ep) return null;
        return (
          <div className="emoji-picker-overlay" onClick={() => setEmojiPickerPerson(null)}>
            <div className="emoji-picker" onClick={(e) => e.stopPropagation()}>
              <div className="emoji-picker-grid">
                {['😎', '🫠', '🕺', '💃', '🍻', '🔊', '💨', '😉', '😐', '😡', '😂', '💩', '👩', '❤️', '🥶', '🐭'].map((emoji) => (
                  <button
                    key={emoji}
                    className={`emoji-option ${ep.emoji === emoji ? 'selected' : ''}`}
                    onClick={() => {
                      updatePersonEmoji(emojiPickerPerson, emoji);
                      setEmojiPickerPerson(null);
                    }}
                  >
                    {emoji}
                  </button>
                ))}
              </div>
            </div>
          </div>
        );
      })()}
    </div>
  );
}
